import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';

export default function HeroSection() {
  const { t } = useTranslation();

  return (
    <section className="relative h-screen w-full overflow-hidden">
      {/* Background Video */}
      <div className="absolute inset-0">
        <iframe
          src="https://www.youtube.com/embed/0e15fZe8c2A?autoplay=1&mute=1&loop=1&playlist=0e15fZe8c2A&controls=0&showinfo=0&rel=0&modestbranding=1&playsinline=1"
          title="Sinjavina Skyrace Background"
          allow="autoplay; encrypted-media"
          className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none"
          style={{
            border: 'none',
            width: '300vw',
            height: '300vh',
            minWidth: '300vw',
            minHeight: '300vh',
          }}
        />
        {/* Dark Overlay for Text Readability */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      {/* Content */}
      <div className="relative h-full flex items-center justify-center">
        <div className="text-center px-4 max-w-4xl mx-auto">
          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="font-futura font-black text-5xl sm:text-6xl md:text-7xl lg:text-8xl text-white mb-8 tracking-tight drop-shadow-2xl"
          >
            {t('common:hero.title')}
          </motion.h1>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="flex flex-col items-center gap-4 mb-8"
          >
            <p className="font-futura font-bold text-2xl sm:text-3xl md:text-4xl text-white tracking-widest">
              {t('common:hero.date')}
            </p>
            <div className="w-16 h-1 bg-primary"></div>
            <p className="font-futura font-bold text-2xl sm:text-3xl md:text-4xl text-white tracking-widest">
              {t('common:hero.location')}
            </p>
          </motion.div>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            className="text-white/90 text-lg sm:text-xl max-w-2xl mx-auto mb-12 leading-relaxed"
          >
            {t('common:hero.description')}
          </motion.p>

          <motion.a
            href="https://www.avaibooksports.com/inscripcion/sinjavina-skyrace/inscripcion_datos/"
            target="_blank"
            rel="noopener noreferrer"
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8, delay: 0.6 }}
            className="inline-block bg-primary hover:bg-primary-dark text-white font-futura font-bold text-lg px-12 py-5 rounded-full transition-all duration-300 hover:scale-105 hover:shadow-2xl whitespace-nowrap cursor-pointer"
          >
            {t('common:hero.cta')} <i className="ri-arrow-right-line ml-2"></i>
          </motion.a>
        </div>
      </div>

      {/* Scroll Indicator */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1, delay: 1 }}
        className="absolute bottom-8 left-1/2 transform -translate-x-1/2"
      >
        <motion.div
          animate={{ y: [0, 10, 0] }}
          transition={{ duration: 1.5, repeat: Infinity }}
          className="text-white text-3xl cursor-pointer"
        >
          <i className="ri-arrow-down-line"></i>
        </motion.div>
      </motion.div>
    </section>
  );
}